
































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import RecebimentoStore from '@/components/Recebimento/Store/RecebimentoStore'

@Component
export default class ModalAddTabelaOperadora extends Vue {
  $refs!: {
    form: any,
  }

  form: any = {
    valid: true,
    nome: [(v: any) => !!v || 'Campo obrigatório'],
  }

  loadSaveAddOperadora: boolean = false
  get loadingSaveAddOperadora() { return this.loadSaveAddOperadora }
  set loadingSaveAddOperadora(value: boolean) { this.loadSaveAddOperadora = value }

  get getRecebimentoStore() {
    return getModule(RecebimentoStore, this.$store)
  }

  get operadorasList() { return this.getRecebimentoStore.operadorasList }

  get showModalAddTabelaOperadora() { return this.getRecebimentoStore.modalAddTabelaOperadora }
  set showModalAddTabelaOperadora(value: boolean) { this.getRecebimentoStore.setModalAddTabelaOperadora(value) }

  get selectedOperadora() { return this.getRecebimentoStore.selectedOperadora }
  set selectedOperadora(value: any) { this.getRecebimentoStore.setSelectedOperadora(value) }

  async saveAddOperadora() {
    this.loadingSaveAddOperadora = true
    if (!(await this.$refs.form.validate())) {
      this.loadingSaveAddOperadora = false
      return
    }
    const response = await this.getRecebimentoStore.postTabelaOperadora()
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Operadora adicionada com sucesso!', icon: 'done', color: '#2E7D32' })
      await this.getRecebimentoStore.getTabelaOperadora(this.getRecebimentoStore.tabelaPrecoId)
      this.showModalAddTabelaOperadora = false
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Erro ao adicionar a operadora!', icon: 'warning', color: '#C62828' })
    }
    this.loadingSaveAddOperadora = false
  }

  @Watch('showModalAddTabelaOperadora')
  onChangeShowModalEditarHospital(value: boolean) {
    if (!value) {
      this.$refs.form.resetValidation()
      this.$refs.form.reset()
    }
  }
}
